export default class Subpage {

    constructor(props={}, onlineAppNavOption=null) {
        this.onlineAppNavOption = onlineAppNavOption;

        this.name = props.name;
        this.code = props.code;
        this.slug = props.slug;
    }

}